module.exports = __webpack_public_path__ + "img/49.1.4c449c6d.jpg";